import React from 'react';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider.v2';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { Url, URLS, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import DuperbrowseContext from '../../../../../contexts/DuperbrowseContext';
import AddItemCard from '../../_partials/AddItemCard';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import ShopThumb, {
  ShopThumbType,
  PANEL_HEIGHT,
  DEFAULT_THUMB_HEIGHT,
} from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Shop';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PremiumContentEmptyState from '../../_partials/PremiumContentEmptyState';

export interface Props {
  streamId: string;
  moduleId: number;
  premiumContentDeviations: PapiDeviation[];
  total: number;
  isOwner: boolean;
  username: string;
  isMobile?: boolean;
  isPaywalUpdates?: boolean;
}

export class PremiumContentSlider extends React.Component<
  Props & WidgetBoxProps & WithTranslation
> {
  render() {
    const {
      isMobile,
      isOwner,
      isPaywalUpdates,
      streamId,
      t,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      moduleId,
      premiumContentDeviations,
      total,
      username,
      section,
      zone,
    } = this.props;

    const isEmpty = !premiumContentDeviations.length;
    const showAddItemCard = isPaywalUpdates && isOwner;

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={t!('common.premiumContent')}
        count={total}
        moduleId={moduleId}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        isEmpty={isEmpty}
        hasMore={!isEmpty} // until we implement inner slider overflow recognition
        emptyView={<PremiumContentEmptyState view={'wide'} />}
        seeAllUrl={Url.userShopPath(
          username,
          USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_CONTENT
        )}
        headerClassName={this.props.headerClassName}
      >
        <DuperbrowseContext
          streamId={streamId}
          deviations={premiumContentDeviations}
          parent={{ title: t('duperbrowse.backButton.profile.shop') }}
        >
          {isMobile ? (
            <SwipeSlider startSlide={showAddItemCard ? 1 : 0}>
              {showAddItemCard && (
                <AddItemCard
                  title={t('pages.shop.premiumContent.addItem.title')}
                  subtitle={t('pages.shop.premiumContent.addItem.subtitle')}
                  onClick={() => window.location.replace(URLS.SUBMIT)}
                  height={PANEL_HEIGHT + DEFAULT_THUMB_HEIGHT}
                  nonCoreMembershipView={
                    <PremiumContentEmptyState view={'small'} />
                  }
                />
              )}
              {premiumContentDeviations.map(deviation => (
                <ShopThumb
                  key={deviation.deviationId}
                  deviation={deviation}
                  type={ShopThumbType.PCP}
                  showAuthor={false}
                />
              ))}
            </SwipeSlider>
          ) : (
            <Slider
              renderSliderItems={elementSize => (
                <>
                  {showAddItemCard && (
                    <AddItemCard
                      title={t('pages.shop.premiumContent.addItem.title')}
                      subtitle={t('pages.shop.premiumContent.addItem.subtitle')}
                      onClick={() => window.location.replace(URLS.SUBMIT)}
                      nonCoreMembershipView={
                        <PremiumContentEmptyState view={'small'} />
                      }
                    />
                  )}
                  {premiumContentDeviations.map(deviation => (
                    <ShopThumb
                      key={deviation.deviationId}
                      deviation={deviation}
                      width={elementSize.width}
                      height={elementSize.height + PANEL_HEIGHT}
                      type={ShopThumbType.PCP}
                      showAuthor={false}
                    />
                  ))}
                </>
              )}
            />
          )}
        </DuperbrowseContext>
      </WidgetBox>
    );
  }
}

export default withMobileContext(withTranslation()(PremiumContentSlider));
